import React, { useState, useEffect } from "react";
import Select from "react-select";
import logo from "../../../assets/Aara_logo.png";
import PhoneInput from "react-phone-input-2";

const CareerCounselingForm = ({
  formData,
  setFormData,
  isSubmitted,
  handleSubmit,
}) => {
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };
  // Updated validate function to work with boolean values
  const validate = () => {
    const newErrors = {};
    const newTouched = { ...touched };

    // Basic Required Fields
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Valid email is required";
    if (!formData.phone) newErrors.phone = "Mobile number is required";
    if (!formData.reference_source)
      newErrors.reference_source = "Reference source is required";
    // Add this to your validate function
    if (formData.parent_email && !/\S+@\S+\.\S+/.test(formData.parent_email))
      newErrors.parent_email = "Please enter a valid email address";
    if (!formData.parents_occupation)
      newErrors.parents_occupation = "Parents occupation is required";
    if (!formData.hobbies) newErrors.hobbies = "Please mention your hobbies";
    if (!formData.school_college_name)
      newErrors.school_college_name = "School/College name is required";
    if (!formData.current_education)
      newErrors.current_education = "Current education is required";
    if (!formData.previous_education)
      newErrors.previous_education = "Previous education is required";
    if (!formData.gpa_percentage)
      newErrors.gpa_percentage = "GPA/Percentage selection is required";
    if (!formData.subjects_liked)
      newErrors.subjects_liked = "Please mention at least one subject you love";
    if (!formData.career_choices)
      newErrors.career_choices = "Please mention your career choices";
    if (!formData.plans_to_study_abroad_future)
      newErrors.plans_to_study_abroad_future = "Please select an option";
    if (!formData.join_family_business)
      newErrors.join_family_business = "Please select an option";
    if (
      formData.competitions_participated === "" ||
      formData.competitions_participated === null
    )
      newErrors.competitions_participated = "Please select an option";
    if (
      formData.good_at_theory_subjects === "" ||
      formData.good_at_theory_subjects === null
    )
      newErrors.good_at_theory_subjects = "Please select an option";
    if (
      formData.technology_innovation_details === "" ||
      formData.technology_innovation_details === null
    )
      newErrors.technology_innovation_details = "Please select an option";
    if (
      formData.associated_with_ngo === "" ||
      formData.associated_with_ngo === null
    )
      newErrors.associated_with_ngo = "Please select an option";
    if (
      formData.interested_in_construction_models === "" ||
      formData.interested_in_construction_models === null
    )
      newErrors.interested_in_construction_models = "Please select an option";
    if (
      formData.interested_in_fashion_design === "" ||
      formData.interested_in_fashion_design === null
    )
      newErrors.interested_in_fashion_design = "Please select an option";
    if (
      formData.interest_in_politics_public_service === "" ||
      formData.interest_in_politics_public_service === null
    )
      newErrors.interest_in_politics_public_service = "Please select an option";
    if (!formData.human_friendly)
      newErrors.human_friendly = "Please select an option";
    if (!formData.interested_in_food_nutrition)
      newErrors.interested_in_food_nutrition = "Please select an option";
    if (!formData.film_related_career_option)
      newErrors.film_related_career_option = "Please select an option";
    if (!formData.personal_details)
      newErrors.personal_details = "Please tell us about yourself";
    else if (formData.personal_details.length > 3000)
      newErrors.personal_details =
        "Response should be limited to 3000 characters";

    // Conditional Validations
    if (
      formData.reference_source === "Others" &&
      !formData.other_reference_source
    ) {
      newErrors.other_reference_source =
        "Please mention the source of reference";
    }

    if (
      formData.reference_source === "Reference of Friend/Relative" &&
      !formData.reference_name_id
    ) {
      newErrors.reference_name_id = "Please mention referral student name";
    }

    if (formData.gpa_percentage === "percentage" && !formData.percentage) {
      newErrors.percentage = "Please enter your percentage";
    }

    if (formData.gpa_percentage === "gpa") {
      if (!formData.gpa) newErrors.gpa = "Enter your GPA";
      if (!formData.out_off)
        newErrors.out_off = "Specify GPA scale (e.g., out of 10)";
    }

    if (
      formData.competitions_participated === true &&
      !formData.competitions_participated_details
    ) {
      newErrors.competitions_participated_details =
        "Please mention the competitions you participated in";
    }

    if (
      formData.good_at_theory_subjects === true &&
      !formData.theory_subjects_good_at_details
    ) {
      newErrors.theory_subjects_good_at_details =
        "Please mention the theory subjects";
    }

    if (
      formData.technology_innovation_details === true &&
      !formData.technology_innovation_details_text
    ) {
      newErrors.technology_innovation_details_text =
        "Please specify the details about technology and innovation";
    }

    if (
      formData.interest_in_politics_public_service === true &&
      !formData.politics_public_service_reason
    ) {
      newErrors.politics_public_service_reason =
        "Please elaborate on your interest in politics";
    }

    // Update the touched state with the new touched fields
    setTouched(newTouched);

    return newErrors;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setTouched(
        Object.keys(validationErrors).reduce(
          (acc, key) => ({ ...acc, [key]: true }),
          {}
        )
      );
    } else {
      setErrors({});
      // There's an issue with how you're calling handleSubmit
      // Your component expects handleSubmit to be a function, but you're trying to pass the event to it
      // Try this instead:
      handleSubmit(e);
    }
  };

  // Update the handleChange function to properly handle boolean string values
  // Updated handleChange function to use actual boolean values
  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;

  //   if (type === "checkbox") {
  //     // Handle checkbox inputs
  //     if (!formData.personal_attributes) {
  //       const updatedAttributes = e.target.checked
  //         ? value
  //         : formData.personal_attributes.filter((item) => item !== value);
  //       setFormData({
  //         ...formData,
  //         personal_attributes: [updatedAttributes],
  //       });
  //     } else {
  //       const updatedAttributes = e.target.checked
  //         ? [...formData.personal_attributes, value]
  //         : formData.personal_attributes.filter((item) => item !== value);
  //       setFormData({
  //         ...formData,
  //         personal_attributes: updatedAttributes,
  //       });
  //     }
  //   } else if (type === "select-one") {
  //     if (value === "true") {
  //       setFormData((prev) => ({ ...prev, [name]: true }));
  //     } else if (value === "false") {
  //       setFormData((prev) => ({ ...prev, [name]: false }));
  //     } else {
  //       setFormData((prev) => ({ ...prev, [name]: "" })); // this ensures "" is tracked too
  //     }
  //   } else {
  //     // For all other inputs, use the value directly
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //   }
  // };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      // Handle checkbox inputs for personal attributes
      if (!formData.personal_attributes) {
        setFormData({
          ...formData,
          personal_attributes: checked ? [value] : [],
        });
      } else {
        const updatedAttributes = checked
          ? [...formData.personal_attributes, value]
          : formData.personal_attributes.filter((item) => item !== value);
        setFormData({
          ...formData,
          personal_attributes: updatedAttributes,
        });
      }
    } else if (type === "select-one") {
      // For boolean selects with "true"/"false" string values
      if (value === "true") {
        setFormData((prev) => ({ ...prev, [name]: true }));
      } else if (value === "false") {
        setFormData((prev) => ({ ...prev, [name]: false }));
      } else {
        // For other dropdown values
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      // For all other input types
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      gpa_percentage: selectedOption ? selectedOption.value : "",
    }));
  };
  const handleReferenceChange = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      setFormData((prevState) => ({
        ...prevState,
        reference_source: value,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        reference: "", // Uncheck and clear the reference when the checkbox is unchecked
      }));
    }
  };

  // Options for GPA/Percentage dropdown
  const gpaOrPercentageOptions = [
    { value: "gpa", label: "GPA" },
    { value: "percentage", label: "Percentage" },
  ];

  const handleAlternatePhoneChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      alternate_phone: value,
    }));
  };

  if (isSubmitted) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
        <img
          src={logo}
          alt="Aara Consultancy Logo"
          className="h-16 sm:h-24 mb-6"
        />
        <h1 className="text-2xl sm:text-4xl font-bold text-gray-800 mb-4 text-center">
          Thank You for Submitting!
        </h1>
        <p className="text-base sm:text-lg text-gray-600 mb-6 text-center">
          We have received your information and will get back to you soon.
        </p>
      </div>
    );
  }

  return (
    <div className="container max-w-4xl mx-auto p-4">
      {/* Logo Section */}
      <div className="flex justify-center mb-6">
        <img src={logo} alt="Aara Consultancy Logo" className="h-16 sm:h-20" />
      </div>
      <form
        onSubmit={onSubmit}
        className="bg-gray-100 shadow-lg p-4 sm:p-6 rounded-lg"
      >
        <h2 className="text-xl sm:text-2xl font-semibold text-center mb-4">
          Career Counseling Student Information Form
        </h2>
        <p className="text-xs sm:text-sm text-gray-500 mb-4">
          Fields marked with * are mandatory and can not be left blank!
        </p>

        <div className="grid grid-cols-1 gap-4">
          {/* Name */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="name"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Name *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.name && errors.name ? "border-red-500" : ""
                }`}
              />
              {touched.name && errors.name && (
                <div className="text-red-500 text-xs mt-1">{errors.name}</div>
              )}
            </div>
          </div>

          {/* Email */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="email"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Email *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.email && errors.email ? "border-red-500" : ""
                }`}
              />
              {touched.email && errors.email && (
                <div className="text-red-500 text-xs mt-1">{errors.email}</div>
              )}
            </div>
          </div>

          {/* Mobile */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="phone"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Mobile No *
            </label>
            <div className="w-full sm:w-1/2">
              <PhoneInput
                country={"in"}
                value={formData.phone || ""}
                // There might be an issue with this line:
                // onChange={(value) => formData.setFieldValue("phone", value)}
                // You're trying to call setFieldValue on formData object which doesn't exist
                // Instead, use:
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, phone: value }))
                }
                onBlur={handleBlur}
                inputProps={{
                  name: "phone",
                  id: "phone",
                  className:
                    touched.phone && errors.phone ? "border-red-500" : "",
                }}
                inputStyle={{
                  width: "100%",
                  height: "40px",
                  borderRadius: "6px",
                  borderColor:
                    touched.phone && errors.phone ? "#f56565" : "#ccc",
                  paddingLeft: "50px",
                }}
                dropdownStyle={{ width: "320px" }}
              />
              {touched.phone && errors.phone && (
                <div className="text-red-500 text-xs mt-1">{errors.phone}</div>
              )}
            </div>
          </div>

          {/* Alternate Contact */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="alternate_phone"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Alternate Contact Number (Parents)
            </label>
            <div className="w-full sm:w-1/2">
              <PhoneInput
                country={"in"}
                value={formData.alternate_phone || ""}
                onChange={handleAlternatePhoneChange}
                inputProps={{
                  name: "alternate_phone",
                  id: "alternate_phone",
                }}
                inputStyle={{
                  width: "100%",
                  height: "40px",
                  borderRadius: "6px",
                  borderColor: "#ccc",
                  paddingLeft: "50px",
                }}
                dropdownStyle={{ width: "320px" }}
              />
            </div>
          </div>

          {/* Reference */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="reference_source"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              How did you get your reference? *
            </label>
            <div className="flex flex-col w-full sm:w-1/2">
              <div
                className={`border rounded-lg p-2 bg-white ${
                  touched.reference_source && errors.reference_source
                    ? "border-red-500"
                    : ""
                }`}
              >
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    name="reference_source"
                    id="reference_friend"
                    value="Reference of Friend/Relative"
                    onChange={handleReferenceChange}
                    checked={
                      formData.reference_source ===
                      "Reference of Friend/Relative"
                    }
                    className="mr-2"
                  />
                  Reference of Friend/Relative
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    name="reference_source"
                    id="reference_word"
                    value="Word of Mouth"
                    onChange={handleReferenceChange}
                    checked={formData.reference_source === "Word of Mouth"}
                    className="mr-2"
                  />
                  Word of Mouth
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    name="reference_source"
                    id="reference_google"
                    value="Google"
                    onChange={handleReferenceChange}
                    checked={formData.reference_source === "Google"}
                    className="mr-2"
                  />
                  Google
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    name="reference_source"
                    id="reference_walkin"
                    value="Walk in"
                    onChange={handleReferenceChange}
                    checked={formData.reference_source === "Walk in"}
                    className="mr-2"
                  />
                  Walk in
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    name="reference_source"
                    id="reference_seminar"
                    value="Seminar"
                    onChange={handleReferenceChange}
                    checked={formData.reference_source === "Seminar"}
                    className="mr-2"
                  />
                  Seminar
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    name="reference_source"
                    id="reference_others"
                    value="Others"
                    onChange={handleReferenceChange}
                    checked={formData.reference_source === "Others"}
                    className="mr-2"
                  />
                  Others
                </label>
              </div>
              {touched.reference_source && errors.reference_source && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.reference_source}
                </div>
              )}
            </div>
          </div>

          {/* Conditional rendering based on selection */}
          {formData.reference_source === "Reference of Friend/Relative" && (
            <div className="flex flex-col sm:flex-row sm:justify-between mt-2 sm:mt-4">
              <label
                htmlFor="reference_name_id"
                className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
              >
                Please mention referral student name (Useful for them to claim
                the referral amount)
              </label>
              <div className="w-full sm:w-1/2">
                <input
                  type="text"
                  id="reference_name_id"
                  name="reference_name_id"
                  value={formData.reference_name_id || ""}
                  onChange={handleChange}
                  className={`border rounded-lg p-2 w-full ${
                    touched.reference_name_id && errors.reference_name_id
                      ? "border-red-500"
                      : ""
                  }`}
                />
                {touched.reference_name_id && errors.reference_name_id && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.reference_name_id}
                  </div>
                )}
              </div>
            </div>
          )}

          {formData.reference_source === "Others" && (
            <div className="flex flex-col sm:flex-row sm:justify-between mt-2 sm:mt-4">
              <label
                htmlFor="other_reference_source"
                className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
              >
                If Others, Mention source of reference
              </label>
              <div className="w-full sm:w-1/2">
                <input
                  type="text"
                  id="other_reference_source"
                  name="other_reference_source"
                  value={formData.other_reference_source || ""}
                  onChange={handleChange}
                  className={`border rounded-lg p-2 w-full ${
                    touched.other_reference_source &&
                    errors.other_reference_source
                      ? "border-red-500"
                      : ""
                  }`}
                />
                {touched.other_reference_source &&
                  errors.other_reference_source && (
                    <div className="text-red-500 text-xs mt-1">
                      {errors.other_reference_source}
                    </div>
                  )}
              </div>
            </div>
          )}

          {/* Parent Email */}
          {/* Parent Email */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="parent_email"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Parents Email ID
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="parent_email"
                name="parent_email"
                value={formData.parent_email || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.parent_email && errors.parent_email
                    ? "border-red-500"
                    : ""
                }`}
              />
              {touched.parent_email && errors.parent_email && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.parent_email}
                </div>
              )}
            </div>
          </div>

          {/* Parents Occupation */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="parents_occupation"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Parents Occupation *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="parents_occupation"
                name="parents_occupation"
                value={formData.parents_occupation || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.parents_occupation && errors.parents_occupation
                    ? "border-red-500"
                    : ""
                }`}
              />
              {touched.parents_occupation && errors.parents_occupation && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.parents_occupation}
                </div>
              )}
            </div>
          </div>

          {/* School Name */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="school_college_name"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              School/College Name *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="school_college_name"
                name="school_college_name"
                value={formData.school_college_name || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.school_college_name && errors.school_college_name
                    ? "border-red-500"
                    : ""
                }`}
              />
              {touched.school_college_name && errors.school_college_name && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.school_college_name}
                </div>
              )}
            </div>
          </div>

          {/* Current Education */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="current_education"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Current education *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="current_education"
                name="current_education"
                value={formData.current_education || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.current_education && errors.current_education
                    ? "border-red-500"
                    : ""
                }`}
              />
              {touched.current_education && errors.current_education && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.current_education}
                </div>
              )}
            </div>
          </div>

          {/* Previous Education */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="previous_education"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Previous education *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="previous_education"
                name="previous_education"
                value={formData.previous_education || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.previous_education && errors.previous_education
                    ? "border-red-500"
                    : ""
                }`}
              />
              {touched.previous_education && errors.previous_education && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.previous_education}
                </div>
              )}
            </div>
          </div>

          {/* GPA/Percentage Dropdown */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="gpa_percentage"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Average GPA/Percentage *
            </label>
            <div className="w-full sm:w-1/2">
              <Select
                id="gpa_percentage"
                name="gpa_percentage"
                options={gpaOrPercentageOptions}
                onChange={handleSelectChange}
                onBlur={handleBlur}
                value={gpaOrPercentageOptions.find(
                  (option) => option.value === formData.gpa_percentage
                )}
                isSearchable
                className={`${
                  touched.gpa_percentage && errors.gpa_percentage
                    ? "is-invalid"
                    : ""
                }`}
              />
              {touched.gpa_percentage && errors.gpa_percentage && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.gpa_percentage}
                </div>
              )}
            </div>
          </div>

          {/* Conditional GPA/Percentage Input */}
          {formData.gpa_percentage === "percentage" && (
            <div className="flex flex-col sm:flex-row sm:justify-between mt-2 sm:mt-4">
              <label
                htmlFor="percentage"
                className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
              >
                Enter your {formData.gpa_percentage}
              </label>
              <div className="w-full sm:w-1/2">
                <div className="relative">
                  <input
                    type="number"
                    id="percentage"
                    name="percentage"
                    value={formData.percentage || ""}
                    onChange={handleChange}
                    placeholder="e.g. 85"
                    className={`border rounded-lg p-2 pr-10 w-full appearance-none focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
                      touched.percentage && errors.percentage
                        ? "border-red-500"
                        : ""
                    }`}
                    min="0"
                    max="100"
                    step="0.01"
                  />
                  <span className="absolute right-3 top-2.5 text-gray-500 text-sm font-medium">
                    %
                  </span>
                </div>
                {touched.percentage && errors.percentage && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.percentage}
                  </div>
                )}
              </div>
            </div>
          )}

          {formData.gpa_percentage === "gpa" && (
            <div className="flex flex-col sm:flex-row sm:justify-between mt-2 sm:mt-4">
              <label
                htmlFor="gpa"
                className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
              >
                Enter GPA (e.g., 5 out of 10)
              </label>
              <div className="flex w-full sm:w-1/2 space-x-2">
                <div className="w-2/5">
                  <input
                    type="number"
                    id="gpa"
                    name="gpa"
                    value={formData.gpa || ""}
                    onChange={handleChange}
                    placeholder="Enter GPA"
                    className={`border rounded-lg p-2 w-full ${
                      touched.gpa && errors.gpa ? "border-red-500" : ""
                    }`}
                    step="0.1"
                    min="0"
                    max="10"
                  />
                  {touched.gpa && errors.gpa && (
                    <div className="text-red-500 text-xs mt-1">
                      {errors.gpa}
                    </div>
                  )}
                </div>
                <div className="flex items-center">
                  <span className="mx-1 text-lg">/</span>
                </div>
                <div className="w-2/5">
                  <input
                    type="number"
                    id="out_off"
                    name="out_off"
                    value={formData.out_off || ""}
                    onChange={handleChange}
                    placeholder="Out of 10"
                    className={`border rounded-lg p-2 w-full ${
                      touched.out_off && errors.out_off ? "border-red-500" : ""
                    }`}
                    min="0"
                  />
                  {touched.out_off && errors.out_off && (
                    <div className="text-red-500 text-xs mt-1">
                      {errors.out_off}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Subjects You Love */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="subjects_liked"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Please mention subjects that you love studying *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="subjects_liked"
                name="subjects_liked"
                value={formData.subjects_liked || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.subjects_liked && errors.subjects_liked
                    ? "border-red-500"
                    : ""
                }`}
              />
              {touched.subjects_liked && errors.subjects_liked && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.subjects_liked}
                </div>
              )}
            </div>
          </div>

          {/* Subjects You Don't Like */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="subjects_disliked"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Subjects you dont like (if any)
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="subjects_disliked"
                name="subjects_disliked"
                value={formData.subjects_disliked || ""}
                onChange={handleChange}
                className="border rounded-lg p-2 w-full"
              />
            </div>
          </div>

          {/* Attributes */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="personal_attributes"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              What kind of attributes do you relate to? (Multiple select)
            </label>
            <div className="w-full sm:w-1/2">
              <div className="border rounded-lg p-2 bg-white grid grid-cols-1 sm:grid-cols-2 gap-x-4">
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_social"
                    value="Social"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Social")
                    }
                    className="mr-2"
                  />
                  Social
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_hardworking"
                    value="Hardworking"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Hardworking")
                    }
                    className="mr-2"
                  />
                  Hardworking
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_extrovert"
                    value="Extrovert"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Extrovert")
                    }
                    className="mr-2"
                  />
                  Extrovert
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_introvert"
                    value="Introvert"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Introvert")
                    }
                    className="mr-2"
                  />
                  Introvert
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_innovative"
                    value="Innovative Thinker"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes(
                        "Innovative Thinker"
                      )
                    }
                    className="mr-2"
                  />
                  Innovative Thinker
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_reader"
                    value="Avid Reader"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Avid Reader")
                    }
                    className="mr-2"
                  />
                  Avid Reader
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_creative"
                    value="Creative"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Creative")
                    }
                    className="mr-2"
                  />
                  Creative
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_dancer"
                    value="Dancer"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Dancer")
                    }
                    className="mr-2"
                  />
                  Dancer
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_business"
                    value="Business Minded"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Business Minded")
                    }
                    className="mr-2"
                  />
                  Business Minded
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_expressive"
                    value="Expressive"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Expressive")
                    }
                    className="mr-2"
                  />
                  Expressive
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_money"
                    value="Money Minded"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Money Minded")
                    }
                    className="mr-2"
                  />
                  Money Minded
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_patient"
                    value="Patient"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Patient")
                    }
                    className="mr-2"
                  />
                  Patient
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_calculative"
                    value="Calculative"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Calculative")
                    }
                    className="mr-2"
                  />
                  Calculative
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_creative_thinker"
                    value="Creative thinker"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Creative thinker")
                    }
                    className="mr-2"
                  />
                  Creative thinker
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_artist"
                    value="Artist"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Artist")
                    }
                    className="mr-2"
                  />
                  Artist
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_sensitive"
                    value="Sensitive"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Sensitive")
                    }
                    className="mr-2"
                  />
                  Sensitive
                </label>
                <label className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id="attr_practical"
                    value="Practical"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Practical")
                    }
                    className="mr-2"
                  />
                  Practical
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    id="attr_others"
                    value="Others"
                    onChange={handleChange}
                    checked={
                      formData.personal_attributes &&
                      formData.personal_attributes.includes("Others")
                    }
                    className="mr-2"
                  />
                  Others
                </label>
              </div>
            </div>
          </div>

          {formData.personal_attributes &&
            formData.personal_attributes.includes("Others") && (
              <div className="flex flex-col sm:flex-row sm:justify-between mt-2">
                <label
                  htmlFor="other_attributes"
                  className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
                >
                  Any other attributes that you can relate to
                </label>
                <div className="w-full sm:w-1/2">
                  <input
                    type="text"
                    id="other_attributes"
                    name="other_attributes"
                    value={formData.other_attributes || ""}
                    onChange={handleChange}
                    className="border rounded-lg p-2 w-full"
                  />
                </div>
              </div>
            )}

          {/* Hobbies */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="hobbies"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Mention your hobbies *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="hobbies"
                name="hobbies"
                value={formData.hobbies || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.hobbies && errors.hobbies ? "border-red-500" : ""
                }`}
              />
              {touched.hobbies && errors.hobbies && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.hobbies}
                </div>
              )}
            </div>
          </div>

          {/* Career Choice */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="career_choices"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Any specific career choices that you have in mind? Reasons for the
              same *
            </label>
            <div className="w-full sm:w-1/2">
              <input
                type="text"
                id="career_choices"
                name="career_choices"
                value={formData.career_choices || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.career_choices && errors.career_choices
                    ? "border-red-500"
                    : ""
                }`}
              />
              {touched.career_choices && errors.career_choices && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.career_choices}
                </div>
              )}
            </div>
          </div>

          {/* Study Plan */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="plans_to_study_abroad_future"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Any plans to study abroad in future? *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="plans_to_study_abroad_future"
                name="plans_to_study_abroad_future"
                value={formData.plans_to_study_abroad_future || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.plans_to_study_abroad_future &&
                  errors.plans_to_study_abroad_future
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="Maybe">Maybe</option>
              </select>
              {touched.plans_to_study_abroad_future &&
                errors.plans_to_study_abroad_future && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.plans_to_study_abroad_future}
                  </div>
                )}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="join_family_business"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Do you wish to join your family business after your education is
              completed? *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="join_family_business"
                name="join_family_business"
                value={formData.join_family_business || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.join_family_business && errors.join_family_business
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="Maybe">Maybe</option>
              </select>
              {touched.join_family_business && errors.join_family_business && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.join_family_business}
                </div>
              )}
            </div>
          </div>
          {/* Competitions */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="competitions_participated"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Have you participated in any competitions in your school life? *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="competitions_participated"
                name="competitions_participated"
                value={
                  formData.competitions_participated === true
                    ? "true"
                    : formData.competitions_participated === false
                    ? "false"
                    : ""
                }
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.competitions_participated &&
                  errors.competitions_participated
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
              {touched.competitions_participated &&
                errors.competitions_participated && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.competitions_participated}
                  </div>
                )}
            </div>
          </div>

          {/* Competitions Details Input (conditional render) */}
          {formData.competitions_participated === true && (
            <div className="flex flex-col sm:flex-row sm:justify-between mt-2">
              <label
                htmlFor="competitions_participated_details"
                className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
              >
                Mention the competitions that you participated in *
              </label>
              <div className="w-full sm:w-1/2">
                <input
                  type="text"
                  id="competitions_participated_details"
                  name="competitions_participated_details"
                  value={formData.competitions_participated_details || ""}
                  onChange={handleChange}
                  className={`border rounded-lg p-2 w-full ${
                    touched.competitions_participated_details &&
                    errors.competitions_participated_details
                      ? "border-red-500"
                      : ""
                  }`}
                />
                {touched.competitions_participated_details &&
                  errors.competitions_participated_details && (
                    <div className="text-red-500 text-xs mt-1">
                      {errors.competitions_participated_details}
                    </div>
                  )}
              </div>
            </div>
          )}

          {/* Theory subjects */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="good_at_theory_subjects"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Are you good at studying theory subjects? Are you an avid reader?
              *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="good_at_theory_subjects"
                name="good_at_theory_subjects"
                value={
                  formData.good_at_theory_subjects === true
                    ? "true"
                    : formData.good_at_theory_subjects === false
                    ? "false"
                    : ""
                }
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.good_at_theory_subjects &&
                  errors.good_at_theory_subjects
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
              {touched.good_at_theory_subjects &&
                errors.good_at_theory_subjects && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.good_at_theory_subjects}
                  </div>
                )}
            </div>
          </div>

          {formData.good_at_theory_subjects === true && (
            <div className="flex flex-col sm:flex-row sm:justify-between mt-2">
              <label
                htmlFor="theory_subjects_good_at_details"
                className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
              >
                Kindly mention what theory subject are you good at
              </label>
              <div className="w-full sm:w-1/2">
                <input
                  type="text"
                  id="theory_subjects_good_at_details"
                  name="theory_subjects_good_at_details"
                  value={formData.theory_subjects_good_at_details || ""}
                  onChange={handleChange}
                  className={`border rounded-lg p-2 w-full ${
                    touched.theory_subjects_good_at_details &&
                    errors.theory_subjects_good_at_details
                      ? "border-red-500"
                      : ""
                  }`}
                />
                {touched.theory_subjects_good_at_details &&
                  errors.theory_subjects_good_at_details && (
                    <div className="text-red-500 text-xs mt-1">
                      {errors.theory_subjects_good_at_details}
                    </div>
                  )}
              </div>
            </div>
          )}

          {/* Technology and Innovation */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="technology_innovation_details"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Are you interested in technology and innovation? *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="technology_innovation_details"
                name="technology_innovation_details"
                value={
                  formData.technology_innovation_details === true
                    ? "true"
                    : formData.technology_innovation_details === false
                    ? "false"
                    : ""
                }
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.technology_innovation_details &&
                  errors.technology_innovation_details
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
              {touched.technology_innovation_details &&
                errors.technology_innovation_details && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.technology_innovation_details}
                  </div>
                )}
            </div>
          </div>

          {formData.technology_innovation_details === true && (
            <div className="flex flex-col sm:flex-row sm:justify-between mt-2">
              <label
                htmlFor="technology_innovation_details_text"
                className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
              >
                Please specify the details about it
              </label>
              <div className="w-full sm:w-1/2">
                <input
                  type="text"
                  id="technology_innovation_details_text"
                  name="technology_innovation_details_text"
                  value={formData.technology_innovation_details_text || ""}
                  onChange={handleChange}
                  className={`border rounded-lg p-2 w-full ${
                    touched.technology_innovation_details_text &&
                    errors.technology_innovation_details_text
                      ? "border-red-500"
                      : ""
                  }`}
                />
                {touched.technology_innovation_details_text &&
                  errors.technology_innovation_details_text && (
                    <div className="text-red-500 text-xs mt-1">
                      {errors.technology_innovation_details_text}
                    </div>
                  )}
              </div>
            </div>
          )}

          {/* NGO Services */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="associated_with_ngo"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Are you actively associated with NGO services? Do you like to help
              community in general? *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="associated_with_ngo"
                name="associated_with_ngo"
                value={
                  formData.associated_with_ngo === true
                    ? "true"
                    : formData.associated_with_ngo === false
                    ? "false"
                    : ""
                }
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.associated_with_ngo && errors.associated_with_ngo
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
              {touched.associated_with_ngo && errors.associated_with_ngo && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.associated_with_ngo}
                </div>
              )}
            </div>
          </div>

          {/* Building Models */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="interested_in_construction_models"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Will you be interested in building models and structures? Are you
              fascinated by how buildings are made? *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="interested_in_construction_models"
                name="interested_in_construction_models"
                value={
                  formData.interested_in_construction_models === true
                    ? "true"
                    : formData.interested_in_construction_models === false
                    ? "false"
                    : ""
                }
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.interested_in_construction_models &&
                  errors.interested_in_construction_models
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
              {touched.interested_in_construction_models &&
                errors.interested_in_construction_models && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.interested_in_construction_models}
                  </div>
                )}
            </div>
          </div>

          {/* Fashion Interest */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="interested_in_fashion_design"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Are you interested in fashion or designing related areas where
              creativity and good drawing is? *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="interested_in_fashion_design"
                name="interested_in_fashion_design"
                value={
                  formData.interested_in_fashion_design === true
                    ? "true"
                    : formData.interested_in_fashion_design === false
                    ? "false"
                    : ""
                }
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.interested_in_fashion_design &&
                  errors.interested_in_fashion_design
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
              {touched.interested_in_fashion_design &&
                errors.interested_in_fashion_design && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.interested_in_fashion_design}
                  </div>
                )}
            </div>
          </div>

          {/* Politics */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="interest_in_politics_public_service"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Are you interested in politics? Do you wish to serve the nation
              and people as a whole? *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="interest_in_politics_public_service"
                name="interest_in_politics_public_service"
                value={
                  formData.interest_in_politics_public_service === true
                    ? "true"
                    : formData.interest_in_politics_public_service === false
                    ? "false"
                    : ""
                }
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.interest_in_politics_public_service &&
                  errors.interest_in_politics_public_service
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
              {touched.interest_in_politics_public_service &&
                errors.interest_in_politics_public_service && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.interest_in_politics_public_service}
                  </div>
                )}
            </div>
          </div>

          {/* Conditional rendering for elaboration input when "Yes" is selected */}
          {formData.interest_in_politics_public_service === true && (
            <div className="flex flex-col sm:flex-row sm:justify-between mt-2">
              <label
                htmlFor="politics_public_service_reason"
                className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
              >
                Please elaborate on your interest in politics and your desire to
                serve the nation
              </label>
              <div className="w-full sm:w-1/2">
                <textarea
                  id="politics_public_service_reason"
                  name="politics_public_service_reason"
                  value={formData.politics_public_service_reason || ""}
                  onChange={handleChange}
                  className={`border rounded-lg p-2 w-full ${
                    touched.politics_public_service_reason &&
                    errors.politics_public_service_reason
                      ? "border-red-500"
                      : ""
                  }`}
                  rows="3"
                />
                {touched.politics_public_service_reason &&
                  errors.politics_public_service_reason && (
                    <div className="text-red-500 text-xs mt-1">
                      {errors.politics_public_service_reason}
                    </div>
                  )}
              </div>
            </div>
          )}

          {/* Human-friendly */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="human_friendly"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Are you human-friendly, patient, and good at understanding people?
              *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="human_friendly"
                name="human_friendly"
                value={formData.human_friendly || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.human_friendly && errors.human_friendly
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="Not Sure">Not Sure</option>
              </select>
              {touched.human_friendly && errors.human_friendly && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.human_friendly}
                </div>
              )}
            </div>
          </div>

          {/* Food Interest */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="interested_in_food_nutrition"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Are you interested in the fields of Food, Nutrition, and Fitness?
              *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="interested_in_food_nutrition"
                name="interested_in_food_nutrition"
                value={formData.interested_in_food_nutrition || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.interested_in_food_nutrition &&
                  errors.interested_in_food_nutrition
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="Only for General Knowledge purpose">
                  Only for General Knowledge purpose
                </option>
              </select>
              {touched.interested_in_food_nutrition &&
                errors.interested_in_food_nutrition && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.interested_in_food_nutrition}
                  </div>
                )}
            </div>
          </div>

          {/* Film-related Career */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="film_related_career_option"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Are you interested in understanding Film-related career options? *
            </label>
            <div className="w-full sm:w-1/2">
              <select
                id="film_related_career_option"
                name="film_related_career_option"
                value={formData.film_related_career_option || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.film_related_career_option &&
                  errors.film_related_career_option
                    ? "border-red-500"
                    : ""
                }`}
              >
                <option value="">Select one from the options below</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="Maybe- Can Consider">Maybe- Can Consider</option>
              </select>
              {touched.film_related_career_option &&
                errors.film_related_career_option && (
                  <div className="text-red-500 text-xs mt-1">
                    {errors.film_related_career_option}
                  </div>
                )}
            </div>
          </div>

          {/* About Yourself */}
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <label
              htmlFor="personal_details"
              className="font-semibold mb-1 sm:mb-0 sm:w-1/2"
            >
              Tell me about yourself. (Describe yourself in detail) *
              <span className="block text-xs text-gray-500 mt-1">
                (Please limit your response to 500 words or 3000 characters.)
              </span>
            </label>
            <div className="w-full sm:w-1/2">
              <textarea
                id="personal_details"
                name="personal_details"
                value={formData.personal_details || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`border rounded-lg p-2 w-full ${
                  touched.personal_details && errors.personal_details
                    ? "border-red-500"
                    : ""
                }`}
                rows="5"
              />
              {touched.personal_details && errors.personal_details && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.personal_details}
                </div>
              )}
              <div className="text-xs text-gray-500 mt-1">
                {formData.personal_details
                  ? `${formData.personal_details.length}/3000 characters`
                  : "0/3000 characters"}
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex justify-center mt-6">
            <button
              type="submit"
              className="bg-red-500 hover:bg-red-600 transition-colors text-white py-2 px-6 rounded-lg font-medium"
              disabled={formData.isSubmitting}
            >
              {formData.isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CareerCounselingForm;
